import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-self-inspection',
  templateUrl: './self-inspection.component.html',
  styleUrls: ['./self-inspection.component.scss']
})
export class SelfInspectionComponent implements OnInit {

  constructor() { }
  
  ngOnInit(): void {
  }

}
